import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  font-family: "Inter", sans-serif;
`;

export const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 24px;
`;

export const PageTitle = styled.h1`
  margin: 0;
  color: #000000;
  font-family: "Suisse International", sans-serif;
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
  letter-spacing: -0.02em;
`;

export const MarkAllButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 16px;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  background: #ffffff;
  color: #1a1a1a;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  svg {
    width: 14px;
    height: 14px;
  }

  &:hover:not(:disabled) {
    background: #f7f7f7;
    border-color: #d1d1d1;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const FiltersBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;

  > div:first-child {
    padding: 0;
    border-bottom: none;
  }
`;

export const TypeFilters = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const TypeFilterPill = styled.button<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  height: 36px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1px solid
    ${({ $active }) => ($active ? "var(--primary-brand)" : "#e5e5e5")};
  background: #ffffff;
  color: ${({ $active }) => ($active ? "var(--primary-brand)" : "#666666")};
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #f7f7f7;
    border-color: ${({ $active }) =>
      $active ? "var(--primary-brand)" : "#d1d1d1"};
  }
`;

export const List = styled.div`
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  background: #ffffff;
`;

export const LoadMoreWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
`;

export const LoadMoreButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 20px;
  border: 1px solid #e5e5e5;
  border-radius: 999px;
  background: #ffffff;
  color: #1a1a1a;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 16px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #f7f7f7;
    border-color: #d1d1d1;
  }
`;

export const Disclaimer = styled.p`
  margin: 16px 0 0;
  text-align: center;
  color: #999999;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
`;
